import eventService from '@/services/events';
import store from '@/store/index.js';
import day from 'dayjs';

/**
 * @returns {Object} initialize state
 */
const initialState = () => {
  return {
    event: {},
    matchScoresByGroupId: {},
  };
};
const state = initialState();

const getters = {
  event() {
    return state.event;
  },
  eventStatus() {
    return state.event.status;
  },
  matchScoresByGroupId(state) {
    return (groupId) => {
      if (state.matchScoresByGroupId[groupId]) {
        return state.matchScoresByGroupId[groupId];
      } else return [];
    };
  },
};

const actions = {
  async getEventById({commit, rootGetters}, id) {
    try {
      const currencySymbol = rootGetters['env/currencySymbol'];
      const result = await eventService.getEventById(id);
      result.groups.forEach((group) => {
        group.startedDate = day(group.startedAt).format('YYYY/MM/DD');
        group.startedTime = day(group.startedAt).format('HH:mm');
        group.endedDate = day(group.endedAt).format('YYYY/MM/DD');
        group.endedTime = day(group.endedAt).format('HH:mm');
        group.priceLabel = `${currencySymbol}${group.price}`;
        group.backstagePriceLabel = `${currencySymbol}${group.backstagePrice}`;
      });
      commit('setEvent', result);
      return result;
    } catch (error) {
      store.commit('env/setIsNotFound', true);
    }
  },
  async getMatchScores({commit, state}, {data, isUpdate, isSearch}) {
    if (state.matchScoresByGroupId[data.groupId] && !isUpdate && !isSearch)
      return state.matchScoresByGroupId[data.groupId];
    const result = await eventService.getMatchScores(data);
    commit('setMatchScores', {
      groupId: data.groupId,
      data: result.rows,
      isUpdate,
    });
    return result;
  },
};

const mutations = {
  setEvent(state, data) {
    state.event = data;
  },
  setMatchScores(state, {groupId, data, isUpdate}) {
    isUpdate
      ? state.matchScoresByGroupId[groupId].push(...data)
      : (state.matchScoresByGroupId[groupId] = data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
